"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSpoilerOrQuoteElement = isSpoilerOrQuoteElement;
exports.prepareSpoilerOrQuote = prepareSpoilerOrQuote;
exports.prepareSpoilersAndQuotes = prepareSpoilersAndQuotes;
var PREPARABLE_TAGS = new Set(['content-spoiler', 'content-quote']);

function isSpoilerOrQuoteElement(content) {
  return PREPARABLE_TAGS.has(content.tagName.toLowerCase());
}

function prepareSpoilerOrQuote(content) {
  if (!isSpoilerOrQuoteElement(content)) return;
  var htmlContent = content;
  if (htmlContent.dataset.prepared) return;
  var placeholder = document.createElement('div');
  var childrenWrapper = document.createElement('div');
  childrenWrapper.className = content.tagName.toLowerCase();

  while (content.firstChild) {
    var child = content.firstChild;
    child.remove();
    childrenWrapper.appendChild(child);
  }

  content.appendChild(placeholder);
  content.appendChild(childrenWrapper);
  htmlContent.dataset.prepared = 'true';
}

function prepareSpoilersAndQuotes(wrapperComponent) {
  wrapperComponent.querySelectorAll('content-spoiler, content-quote').forEach(prepareSpoilerOrQuote);
}